const validation = () => {
    $('.def-validation:not(.js-init)').each((i, el) => {
        el.addEventListener('invalid', (e) => {
            e.preventDefault();
            e.target.classList.add('def-validation__invalid');
        }, true);
        el.addEventListener('focusin', (e) => {
            e.target.classList.remove('def-validation__invalid');
        }, true);
        $(this).addClass('js-init');
    });

    const email = new Inputmask({
        mask: '*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@{1}*{1,20}d{1}*{2,6}[.*{1,2}]',
        greedy: false,
        definitions: {
            '*': {
                validator: "[0-9A-Za-z_-]",
                cardinality: 1,
                casing: "lower"
            },
            '@': {
                validator: '@',
                cardinality: 1,
                casing: 'lower'
            },
            'd': {
                validator: '.',
                cardinality: 1,
                casing: 'lower'
            }
        }
    });
    const phone = new Inputmask({
        mask: '+38 (`{1}~{1}^{1}) ^{3} ^{2} ^{2}',
        definitions: {
            '#': '',
            '^': {
                validator: "[0-9\\s]",
                cardinality: 1,
                casing: "lower"
            },
            '`': {
                validator: "[0]",
                cardinality: 1,
                casing: "lower"
            },
            '~': {
                validator: "[1-9]",
                cardinality: 1,
                casing: "lower"
            },
        },
        oncomplete: (e) => {
            e.target.classList.remove('onincomplete');
            e.target.classList.add('oncomplete');
        },
        onincomplete: (e) => {
            if($(e.target).attr('required')){
                e.target.classList.remove('oncomplete');
                e.target.classList.add('onincomplete');
            }
        },
        oncleared: () => {
            completePhone = false;
            clearIncomplete  = true;
        },
        placeholder: "X",
        // positionCaretOnClick: testMask()
    });
    phone.mask('.def-tel-mask');
    email.mask('.def-email-mask');


    $('.def-email-mask:required').attr('pattern', `^([a-z0-9_-]+\\.)*[a-z0-9_-]+@[a-z0-9_-]+(\\.[a-z0-9_-]+)*\\.[a-z]{2,6}$`);
    $('.def-tel-mask:required').attr('pattern', `\\+[0-9]{2}\\s\\([0-9]{3}\\)\\s[0-9]{3}\\s[0-9]{2}\\s[0-9]{2,6}`);
}

validation();
$('body').on('init-form', validation);